import React, { useEffect, useState } from 'react';
import { Box, Button, Card, CardContent, Chip, Grid, MenuItem, Stack, TextField, Typography } from '@mui/material';
import { IconPlus, IconClipboardList } from '@tabler/icons';
import { useHistory } from 'react-router-dom';
import api from '../../../../services/api';
import PageHeader from '../../../../../ui-component/extended/PageHeader';

const STATUS_LABEL = {
    draft: { label: 'Rascunho', color: 'default' },
    submitted: { label: 'Enviada', color: 'warning' },
    approved: { label: 'Aprovada', color: 'success' },
    rejected: { label: 'Rejeitada', color: 'error' }
};

const ViewAllPurchaseRequests = () => {
    const history = useHistory();

    const [appId, setAppId] = useState(null);
    const [requests, setRequests] = useState([]);
    const [statusFilter, setStatusFilter] = useState('');

    useEffect(() => {
        (async () => {
            const res = await api.get('v1/apps/default/');
            setAppId(res.data.app.id);
        })();
    }, []);

    useEffect(() => {
        if (!appId) return;
        listarSolicitacoes();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [appId, statusFilter]);

    const listarSolicitacoes = async () => {
        const query = statusFilter ? `?status=${statusFilter}` : '';
        const res = await api.get(`v1/apps/${appId}/purchase_requests/${query}`);
        setRequests(res.data.requests || []);
    };

    return (
        <Box>
            <PageHeader
                icon={IconClipboardList}
                gradient="amber"
                title="Solicitações de Compra"
                subtitle="Necessidades internas antes de ir à cotação com fornecedores"
                actions={
                    <Stack direction="row" spacing={2}>
                        <TextField
                            select
                            size="small"
                            label="Status"
                            value={statusFilter}
                            onChange={(e) => setStatusFilter(e.target.value)}
                            sx={{ width: 180 }}
                        >
                            <MenuItem value="">Todos</MenuItem>
                            <MenuItem value="draft">Rascunho</MenuItem>
                            <MenuItem value="submitted">Enviada</MenuItem>
                            <MenuItem value="approved">Aprovada</MenuItem>
                            <MenuItem value="rejected">Rejeitada</MenuItem>
                        </TextField>

                        <Button
                            variant="contained"
                            startIcon={<IconPlus size={18} />}
                            onClick={() => history.push('/dashboard/purchasing/requests/new')}
                        >
                            Nova Solicitação
                        </Button>
                    </Stack>
                }
            />

            <Grid container spacing={2}>
                {requests.map((req) => {
                    const statusInfo = STATUS_LABEL[req.status] || { label: req.status, color: 'default' };
                    return (
                        <Grid item xs={12} key={req.id}>
                            <Card sx={{ cursor: 'pointer' }} onClick={() => history.push(`/dashboard/purchasing/requests/${req.id}/`)}>
                                <CardContent>
                                    <Grid container alignItems="center" spacing={2}>
                                        <Grid item xs={12} sm={5}>
                                            <Typography fontWeight={600}>{req.justification || 'Sem justificativa informada'}</Typography>
                                            <Typography variant="caption" color="text.secondary">
                                                Solicitado por {req.requested_by_name || '-'}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={6} sm={4}>
                                            <Typography variant="caption" color="text.secondary">
                                                {new Date(req.created_at).toLocaleDateString('pt-BR')}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={6} sm={3}>
                                            <Chip label={statusInfo.label} color={statusInfo.color} size="small" />
                                        </Grid>
                                    </Grid>
                                </CardContent>
                            </Card>
                        </Grid>
                    );
                })}
            </Grid>

            {requests.length === 0 && (
                <Box mt={10} textAlign="center" color="text.secondary">
                    <Typography variant="h6">Nenhuma solicitação encontrada</Typography>
                </Box>
            )}
        </Box>
    );
};

export default ViewAllPurchaseRequests;
